// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IPlaceOrderResponseModel } from './iPlaceOrderResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimV1PlaceOrderDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': IPlaceOrderResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimV1PlaceOrderDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "IPlaceOrderResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimV1PlaceOrderDefaultResponse.attributeTypeMap;
    }
}
